export interface IncomeTaxDeclarationOne {
    item?: string,
    align?: string,
    col?: string,
    title?: string,
    quantity?: string,
    amount?: string,
    indent?: number | string,
    isHead?: boolean,
    row?: string,
    justCol3?: boolean,
    canEdit?: boolean,
    rowspan?: number,
    itemSecond?: string,
    isNo?: boolean,
    isTechSmall?: boolean,
    isTechHigh?: boolean,
    isTechShare?: boolean,
    isStateLimit?: boolean,
    isSmallLowProfit?: boolean,
    changeType?: string,
    changeType2?: string,
    startPersonNum?: string | null,
    endPersonNum?: string | null,
    startAssets?: string,
    endAssets?: string,
    attr?: string,
    colspan?: string,
    isL15?: boolean,
}

let list: IncomeTaxDeclarationOne[] = [
    {
        title: "预缴税款计算",
        colspan: "12",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        item: "项目",
        align: "center",
        col: "栏次",
        amount: "本年累计金额",
        indent: 0,
        isHead: true
    },
    {
        item: "营业收入",
        align: "left",
        col: "1",
        row: "1",
        amount: "0",
        attr: "row1",
    },
    {
        item: "营业成本",
        align: "left",
        col: "2",
        row: "1",
        amount: "0",
        attr: "row2",
    },
    {
        item: "利润总额",
        align: "left",
        col: "3",
        row: "1",
        amount: "0",
        attr: "row3",
    },
    {
        item: "加：特定业务计算的应纳税所得额",
        align: "left",
        col: "4",
        row: "1",
        amount: "0",
        attr: "row4",
    },
    {
        item: "减：不征税收入",
        align: "left",
        col: "5",
        row: "1",
        amount: "0",
        attr: "row5",
    },
    {
        item: "减：免税收入、减计收入、所得税减免等优惠金额",
        align: "left",
        col: "6",
        row: "1",
        amount: "0",
        attr: "row6",
    },
    {
        item: "减：固定资产加速折旧（扣除）调减额（填写A201020）",
        align: "left",
        col: "7",
        row: "1",
        amount: "0",
        attr: "row7",
    },
    {
        item: "减：弥补以前年度亏损",
        align: "left",
        col: "8",
        row: "1",
        amount: "0",
        attr: "row8",
        canEdit: true
    },
    {
        item: "实际利润额（3+4-5-6-7-8）\按照上一纳税年度应纳税所得额平均额确定的应纳税所得额",
        align: "left",
        col: "9",
        row: "1",
        amount: "0",
        attr: "row9",
    },
    {
        item: "税率（25%）",
        align: "left",
        col: "10",
        row: "1",
        amount: "0",
        attr: "row10",
    },
    {
        item: "应纳所得税额（9行×10行）",
        align: "left",
        col: "11",
        row: "1",
        amount: "0",
        attr: "row11",
    },
    {
        item: "减：减免所得税额（填写A201030）",
        align: "left",
        col: "12",
        row: "1",
        amount: "0",
        attr: "row12",
    },
    {
        item: "减：实际已缴纳所得税额",
        align: "left",
        col: "13",
        row: "1",
        amount: "0",
        attr: "row13",
        canEdit: true
    },
    {
        item: "减：特定业务预缴（征）所得税额",
        align: "left",
        col: "14",
        row: "1",
        amount: "0",
        attr: "row14",
        canEdit: true
    },
    {
        item: "减：符合条件的小型微利企业延缓缴纳所得税额",
        align: "left",
        col: "L15",
        row: "1",
        amount: "0",
        attr: "rowL15",
        isL15: true,
        canEdit: true


    },
    {
        item: "本期应补（退）所得税额（11-12-13-14-L15）\税务机关确定的本期应纳所得税额",
        align: "left",
        col: "15",
        row: "1",
        amount: "0",
        attr: "row15",
    },
    {
        title: "汇总纳税企业总分机构税款计算",
        colspan: "12",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        itemSecond: "总机构本期分摊应补（退）所得税额（17+18+19）",
        align: "left",
        col: "16",
        row: "1",
        quantity: "总机构填报",
        amount: "0",
        attr: "row16",
        rowspan: 4,
    },
    {
        itemSecond: "其中：总机构分摊应补（退）所得税额（15×总机构分摊比例25%）",
        align: "left",
        col: "17",
        row: "1",
        amount: "0",
        attr: "row17",
        canEdit: true

    },
    {
        itemSecond: "财政集中分配应补（退）所得税额（15×财政集中分配比例25%）",
        align: "left",
        col: "18",
        row: "1",
        amount: "0",
        attr: "row18",
        canEdit: true

    },
    {
        itemSecond: "总机构具有主体生产经营职能的部门分摊所得税额（15×全部分支机构分摊比例50%×总机构具有主体生产经营职能部门分摊比例0.00%）",
        align: "left",
        col: "19",
        row: "1",
        amount: "0",
        attr: "row19",
        canEdit: true

    },
    {
        itemSecond: "分支机构本期分摊比例",
        align: "left",
        col: "20",
        row: "1",
        quantity: "分支机构填报",
        amount: "0",
        attr: "row20",
        rowspan: 2,
        canEdit: true

    },
    {
        itemSecond: "分支机构本期分摊应补（退）所得税额",
        align: "left",
        col: "21",
        row: "1",
        amount: "0",
        attr: "row21",
        canEdit: true

    },
    {
        title: "附报信息",
        colspan: "12",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        justCol3: true,
        isNo: true,
        align: "left",
        changeType2: "科技型中小企业：",
        isTechSmall: true,
    },
    {
        justCol3: true,
        changeType: "高新技术企业：",
        isTechHigh: true,
        align: "left",
        changeType2: "技术入股递延纳税事项：",
        isTechShare: true,
    },
    // {
    //     title: "按季度填报信息",
    //     colspan: "12",
    //     align: "center",
    //     indent: 0,
    //     isHead: true
    // },
    // {
    //     justCol3: true,
    //     startPersonNum: "0",
    //     changeType: "季初从业人数",
    //     align: "left",
    //     endPersonNum: "0",
    //     changeType2: "季末从业人数",
    //     canEdit: true
    // },
    // {
    //     justCol3: true,
    //     startAssets: "0",
    //     changeType: "季初资产总额（万元）",
    //     align: "left",
    //     endAssets: "0",
    //     changeType2: "季末资产总额（万元）",
    //     canEdit: true
    // },
    // {
    //     justCol3: true,
    //     changeType: "国家限制或禁止行业：",
    //     isStateLimit: true,
    //     align: "left",
    //     changeType2: "小型微利企业：",
    //     isSmallLowProfit: true,
    // },
]


let EITQuarterList = list
export default EITQuarterList
